<template>
    <div v-if="additionalId">
        <CRow class="pl-3">Банер</CRow>
        <div class="overflow-hidden border border-gray-300 rounded-md pl-2 pr-2 pt-2">
            <Draggable
                v-model="list"
                tag="div"
                class="custom__grid"
            >
                <div
                    v-for="item in list"
                    :key="item.id"
                    class="flex items-center custom__card cursor-pointer"
                    @click="item.add ? openModal() : () => false"
                >
                    <CButton
                        v-if="!item.add"
                        shape="pill"
                        color="danger"
                        class="custom__card__btn-delete"
                        @click="remove(item.id)"
                    >
                        <CIcon
                            size="sm"
                            :content="$options.icons.cilTrash"
                            class="handle"
                        />
                    </CButton>
                    <img
                        v-if="!item.add"
                        :src="bannerUrl(item.banner)"
                        alt="Банер"
                    />
                    <CButton
                        v-else
                        shape="pill"
                        color="success"
                        variant="outline"
                    >
                        <CIcon
                            size="xl"
                            :content="$options.icons.cilPlus"
                            class="handle"
                        />
                    </CButton>
                </div>
            </Draggable>

            <CModal
                title="Добавить банер"
                :show.sync="open"
                :footer="false"
                color="info"
            >
                <template>
                    <div slot="body-wrapper" class="modal-body">
                        <CForm>
                            <CRow>
                                <CCol>
                                    <CInputFile
                                        ref="banner"
                                        label="Банер"
                                        horizontal
                                        @change="selectBanner" />
                                </CCol>
                            </CRow>
                        </CForm>
                    </div>
                    <div slot="footer">
                        <CButton
                            color="light"
                            class="ml-3"
                            @click="open = false"
                        >Отмена</CButton
                        >
                        <CButton
                            color="primary"
                            class="ml-3"
                            @click="create"
                        >Добавить</CButton
                        >
                    </div>
                </template>
            </CModal>
        </div>
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import { cilPlus, cilTrash } from '@coreui/icons';

export default {
    name: 'EntityAdditionalBanners',

    icons: {
        cilPlus,
        cilTrash
    },

    components: {
        Draggable
    },

    props: {
        banners: {
            type: Array,
            default: () => []
        },
        additionalId: {
            type: Number,
            default: null
        },
        entityId: {
            type: Number,
            default: null
        },
    },

    data: () => ({
        list: [],
        selectedBanner: null,
        open: false,
    }),

    computed: {},

    watch: {
        banners: {
            deep: true,
            handler() {
                const data = [...this.banners];
                data.push({
                    id: 0,
                    position: data.length,
                    add: true
                });
                this.list = data;
            }
        },
        async list() {
            const banners = this.list
                .filter(cover => !cover.add)
                .map((cover, idx) => ({ ...cover, position: idx + 1 }));

            await this.axios.post(`/entities/${this.entityId}/additional/${this.additionalId}/banners/reorder`, { banners });
        }
    },

    methods: {
        selectBanner(FileList) {
            this.selectedBanner = FileList[0];
        },

        bannerUrl(url) {
            return process.env.VUE_APP_STATIC_BASE_URL + '/' + url;
        },

        openModal() {
            this.open = !this.open;
        },

        async create() {
            if (!this.selectedBanner) {
                this.$root.$emit('showError', 'Не выбрано изображение.');
            }
            try {
                let formData = new FormData();
                formData = new FormData();
                formData.append('file', this.selectedBanner);
                const uploadBanner = await this.axios.post('/files/upload', formData);
                await this.axios.post(`/entities/${this.entityId}/additional/${this.additionalId}/banners`, {
                    entity_additional_id: this.additionalId,
                    banner: uploadBanner.data.filename,
                    position: 1,
                });
                this.open = !this.open;
                this.$emit('banners-update');
            } catch (error) {
                this.$root.$emit('showError', 'Не удалось обновить данные. ' + error);
            }
        },
        async remove(id) {
            try {
                await this.axios.delete(`/entities/${this.entityId}/additional/${this.additionalId}/banners/${id}`);
                this.$emit('banners-update');
            } catch (error) {
                this.$root.$emit('showError', 'Не удалось обновить данные. ' + error);
            }
        },
    }
}
</script>
<style scoped lang="scss">
.custom__grid {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.custom__card {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 24%;
    height: 140px;
    margin-right: 11px;
    margin-bottom: 11px;

    position: relative;

    border: 2px solid #e2e8f0;
    border-radius: 5px;
    overflow: hidden;

    &__btn-delete {
        position: absolute;
        bottom: 10px;
        right: 10px;
    }

    img {
        display: block;
        width: 100%;
        max-width: 100%;
    }

    &:nth-child(4n) {
        margin-right: 0;
    }
}
</style>
